import React from "react";
import { Truck, Check } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { FREE_SHIP_THRESHOLD, money } from "@/data/products";

/**
 * Live free-shipping progress nudge for product pages.
 * variant: "bar" (full-width strip) | "inline" (compact card)
 */
export const FreeShipBanner = ({ variant = "bar", className = "" }) => {
  const { count, freeShip, freeShipRemaining } = useCart();

  const empty = count === 0;
  const spent = FREE_SHIP_THRESHOLD - freeShipRemaining;
  const pct = empty ? 0 : Math.min(100, Math.max(0, (spent / FREE_SHIP_THRESHOLD) * 100));

  let text;
  let done = false;
  if (freeShip && !empty) { text = "You've unlocked free shipping"; done = true; }
  else if (empty) text = `Free shipping on orders $${FREE_SHIP_THRESHOLD}+`;
  else text = <>Spend <span className="text-[#D4AF37] font-semibold">{money(freeShipRemaining)}</span> more for free shipping</>;

  return (
    <div
      data-testid="freeship-banner"
      className={`flex items-center gap-3 border ${done ? "border-emerald-400/40 bg-emerald-400/[0.06]" : "border-[#D4AF37]/30 bg-[#D4AF37]/[0.05]"} ${variant === "bar" ? "px-4 py-2.5" : "px-4 py-3"} ${className}`}
    >
      {done ? <Check size={15} className="text-emerald-400 shrink-0" /> : <Truck size={15} className="text-[#D4AF37] shrink-0" />}
      <div className="flex-1 min-w-0">
        <p className={`font-mono text-[11px] tracking-wide ${done ? "text-emerald-400" : "text-[#E8E8E3]"}`} data-testid="freeship-banner-text">{text}</p>
        {!empty && !done && (
          <div className="mt-1.5 h-[3px] w-full bg-white/10 overflow-hidden">
            <div className="h-full bg-[#D4AF37] transition-all duration-500" style={{ width: `${pct}%` }} data-testid="freeship-banner-bar" />
          </div>
        )}
      </div>
    </div>
  );
};

export default FreeShipBanner;
